import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M20.9346 13.2175L19.3688 19.1016C19.1078 20.2173 18.1179 21 16.9661 21H8.39926V10.2216L9.94705 4.64341C10.127 3.4558 11.3599 2.66402 12.6107 3.14087C13.3576 3.42877 13.7985 4.20252 13.7985 5.00326V9.31287C13.7985 9.80771 14.2035 10.1946 14.6984 10.1946H18.5319C20.1247 10.1946 21.2945 11.6701 20.9346 13.2175ZM3 12.012V19.2096C3 20.1993 3.80989 20.991 4.79975 20.991H6.59951V10.1946H4.79975C3.80989 10.1946 3 11.0223 3 12.012Z' />
        </SvgIcon>
    );
});
